// Mock data for DEBECO website

export const blogArticles = [
  {
    id: '1',
    title: 'Combien coûte un débarras de maison à Annecy ?',
    slug: 'cout-debarras-maison-annecy',
    excerpt: 'Découvrez les différents facteurs qui influencent le prix d\'un débarras de maison dans la région annécienne et comment obtenir le meilleur rapport qualité-prix.',
    content: `Le coût d'un débarras de maison à Annecy dépend de plusieurs facteurs essentiels. Le volume des biens à évacuer est le premier critère : un studio nécessitera moins de ressources qu'une maison de 4 pièces. L'accessibilité du logement joue également un rôle important.

Les tarifs varient généralement entre 300€ et 2000€ selon la taille du bien. Pour un appartement T2, comptez environ 400-700€. Pour une maison complète, le prix peut atteindre 1500-2500€.

Certains objets de valeur peuvent être repris, ce qui peut réduire ou annuler complètement le coût du débarras. N'hésitez pas à demander un devis gratuit pour obtenir une estimation précise adaptée à votre situation.`,
    image: '/images/maison.jpg',
    date: '2024-01-15',
    author: 'Équipe DEBECO',
    category: 'Tarifs'
  },
  {
    id: '2',
    title: 'Que faire des vieux meubles en Savoie ?',
    slug: 'vieux-meubles-savoie',
    excerpt: 'Guide complet pour valoriser, recycler ou donner vos anciens meubles en Savoie. Solutions écologiques et responsables.',
    content: `En Savoie, plusieurs solutions s'offrent à vous pour vos vieux meubles. Le recyclage est la première option à considérer : les déchetteries locales acceptent le mobilier et assurent leur traitement écologique.

Les associations comme Emmaüs ou La Croix-Rouge récupèrent les meubles en bon état pour leur donner une seconde vie. Vous pouvez également les revendre sur des plateformes comme Le Bon Coin ou Vinted.

Notre service de débarras DEBECO s'occupe de tout : nous trions, valorisons ce qui peut l'être, et recyclons le reste dans le respect de l'environnement. Une solution clé en main pour un débarras responsable.`,
    image: '/images/garage.jpg',
    date: '2024-01-10',
    author: 'Équipe DEBECO',
    category: 'Recyclage'
  },
  {
    id: '3',
    title: 'Débarras gratuit : comment ça marche vraiment ?',
    slug: 'debarras-gratuit-fonctionnement',
    excerpt: 'Le débarras gratuit est-il vraiment possible ? Découvrez dans quels cas votre débarras peut ne rien vous coûter.',
    content: `Le débarras gratuit est possible lorsque la valeur des objets récupérables couvre les frais d'intervention. Cela concerne principalement les biens contenant des meubles anciens, antiquités, ou objets de collection.

Lors de notre visite, nous évaluons le mobilier présent. Si des pièces ont une valeur marchande (meubles vintage, électroménager récent, objets décoratifs), elles peuvent être reprises et revendues.

Le débarras devient alors gratuit, voire rémunéré dans certains cas exceptionnels. Pour les débarras standards, nos tarifs restent très compétitifs. Contactez-nous pour une estimation gratuite et personnalisée !`,
    image: '/images/appartement.jpg',
    date: '2024-01-05',
    author: 'Équipe DEBECO',
    category: 'Conseils'
  },
  {
    id: '4',
    title: 'Comment vider une maison après une succession ?',
    slug: 'vider-maison-succession',
    excerpt: 'Guide pratique pour organiser le débarras d\'une maison après un décès. Accompagnement et conseils.',
    content: `Le débarras après succession est une étape délicate qui nécessite organisation et sensibilité. Commencez par identifier les objets de valeur sentimentale ou marchande que les héritiers souhaitent conserver.

Tri des documents administratifs, inventaire des biens, coordination avec le notaire : autant d'étapes que nous pouvons faciliter. Notre équipe intervient avec respect et discrétion.

Nous proposons un accompagnement complet : tri sélectif, mise de côté des objets personnels, évacuation du mobilier, nettoyage léger. Nos équipes sont formées pour gérer ces situations sensibles avec professionnalisme et empathie.`,
    image: '/images/succession.jpg',
    date: '2023-12-28',
    author: 'Équipe DEBECO',
    category: 'Succession'
  },
  {
    id: '5',
    title: 'Débarras rapide avant un déménagement : guide complet',
    slug: 'debarras-rapide-demenagement',
    excerpt: 'Optimisez votre déménagement avec un débarras efficace. Tous nos conseils pour gagner du temps et de l\'argent.',
    content: `Un déménagement approche ? C'est le moment idéal pour désencombrer ! Commencez le tri 2-3 semaines avant la date prévue pour éviter le stress de dernière minute.

Notre service de débarras express intervient en 24-48h pour évacuer tout ce dont vous ne voulez plus : vieux meubles, électroménager, objets encombrants. Vous gagnez du temps et réduisez le volume à déménager.

Les avantages : réduction des coûts de déménagement, logement plus facile à présenter pour la visite de sortie, et sérénité retrouvée. Demandez votre devis gratuit dès aujourd'hui !`,
    image: '/images/professionnel.jpg',
    date: '2023-12-20',
    author: 'Équipe DEBECO',
    category: 'Déménagement'
  }
];

export const services = [
  {
    id: 'maison',
    title: 'Débarras de maison',
    icon: 'Home',
    shortDesc: 'Vide-maison complet et rapide',
    description: 'Service complet pour vider une maison avant déménagement, vente ou travaux. Tri, récupération, recyclage, évacuation.',
    details: [
      'Intervention rapide sous 48-72h',
      'Tri sélectif de tous les biens',
      'Offrir une seconde vie aux objets en état d\'usage',
      'Balayage après intervention'
    ],
    image: '/images/maison.jpg'
  },
  {
    id: 'appartement',
    title: 'Débarras d\'appartement',
    icon: 'Building2',
    shortDesc: 'Intervention même sans ascenseur',
    description: 'Intervention efficace même dans les lieux difficiles d\'accès : étages, petites cages d\'escalier, absence d\'ascenseur.',
    details: [
      'Équipe formée pour les accès difficiles',
      'Protection des parties communes',
      'Matériel adapté (sangles, diables, protection)',
      'Respect des horaires et du voisinage'
    ],
    image: '/images/appartement.jpg'
  },
  {
    id: 'cave-grenier',
    title: 'Débarras cave, grenier & garage',
    icon: 'Warehouse',
    shortDesc: 'Désencombrement espaces de stockage',
    description: 'Désencombrement total des espaces de stockage, tri et évacuation des objets lourds ou encombrants.',
    details: [
      'Accès aux caves et greniers',
      'Évacuation d\'objets lourds',
      'Tri et recyclage systématique',
      'Nettoyage sommaire de l\'espace'
    ],
    image: '/images/garage.jpg'
  },
  {
    id: 'professionnel',
    title: 'Débarras professionnel',
    icon: 'Briefcase',
    shortDesc: 'Bureaux, commerces, locaux, archives',
    description: 'Débarras de mobilier professionnel, rayonnages, archives, matériel obsolète, équipements divers.',
    details: [
      'Mobilier de bureau et rangements',
      'Matériel informatique obsolète',
      'Archives et documentation',
      'Intervention hors horaires si besoin'
    ],
    image: '/images/professionnel.jpg'
  },
  {
    id: 'succession',
    title: 'Débarras succession',
    icon: 'Heart',
    shortDesc: 'Accompagnement après décès',
    description: 'Accompagnement complet après un décès : tri, enlèvement des meubles, préparation du bien pour la vente ou la remise aux héritiers.',
    details: [
      'Intervention respectueuse et discrète',
      'Mise de côté des objets personnels',
      'Coordination avec notaires et héritiers',
      'Gestion administrative facilitée'
    ],
    image: '/images/succession.jpg'
  }
];

export const zones = [
  {
    id: 'annecy',
    title: 'Annecy et bassin Annécien',
    description: 'Intervention sur Annecy et l\'ensemble du bassin annécien ainsi que le pourtour du lac d\'Annecy.',
    cities: ['Annecy', 'Annecy-le-Vieux', 'Cran-Gevrier', 'Seynod', 'Meythet', 'Poisy', 'Argonay', 'Epagny-Metz-Tessy', 'Villaz', 'Sevrier', 'Saint-Jorioz', 'Veyrier-du-Lac', 'Menthon-Saint-Bernard', 'Talloires-Montmin', 'Duingt', 'Rumilly', 'Thônes', 'Frangy']
  },
  {
    id: 'mont-blanc',
    title: 'Pays du Mont Blanc - Chablais - Aravis',
    description: 'Stations de ski et vallées de montagne de Haute-Savoie : Chamonix, Megève, La Clusaz et le Chablais.',
    cities: ['Chamonix', 'Megève', 'La Clusaz', 'Le Grand-Bornand', 'Sallanches', 'Passy', 'Saint-Gervais', 'Thonon-les-Bains', 'Évian-les-Bains', 'Morzine', 'Les Gets', 'Avoriaz', 'Manigod', 'Le Reposoir']
  },
  {
    id: 'aix-chambery',
    title: 'Aix-les-Bains - Chambéry - Maurienne - Tarentaise',
    description: 'Aix-les-Bains, Chambéry et les grandes vallées de Savoie : Maurienne et Tarentaise.',
    cities: ['Aix-les-Bains', 'Chambéry', 'La Ravoire', 'Albertville', 'Le Bourget-du-Lac', 'Montmélian', 'Saint-Jean-de-Maurienne', 'Modane', 'Bourg-Saint-Maurice', 'Tignes', 'Val-d\'Isère', 'Courchevel', 'Méribel', 'Les Arcs', 'La Rosière']
  },
  {
    id: 'genevois',
    title: 'Genevois',
    description: 'Couverture complète du Genevois français, de la frontière suisse aux vallées environnantes.',
    cities: ['Saint-Julien-en-Genevois', 'Annemasse', 'Ambilly', 'Gaillard', 'Archamps', 'Valleiry', 'Viry', 'Neydens', 'Cruseilles', 'Allonzier-la-Caille', 'Collonges-sous-Salève', 'Feigères', 'Vétraz-Monthoux']
  },
  {
    id: 'pays-arve',
    title: 'Vallée de l\'Arve',
    description: 'Vallée de l\'Arve, de Bonneville à Cluses et les communes environnantes.',
    cities: ['Bonneville', 'Cluses', 'Scionzier', 'Thyez', 'Marignier', 'Marnaz', 'Mont-Saxonnex', 'La Roche-sur-Foron', 'Saint-Pierre-en-Faucigny', 'Ayze', 'Vougy', 'Magland']
  },
  {
    id: 'pays-gex',
    title: 'Pays de Gex',
    description: 'Le Pays de Gex dans l\'Ain, entre le Jura et la frontière suisse.',
    cities: ['Gex', 'Divonne-les-Bains', 'Ferney-Voltaire', 'Saint-Genis-Pouilly', 'Prévessin-Moëns', 'Ornex', 'Thoiry', 'Cessy', 'Crozet', 'Ségny', 'Chevry']
  }
];

export const faqs = [
  {
    id: '1',
    question: 'Qu\'est-ce que DEBECO fait exactement ?',
    answer: 'DEBECO réalise des débarras (maison, appartement, cave, grenier, garage, locaux commerciaux), du nettoyage après débarras, et de des biens récupérables.'
  },
  {
    id: '2',
    question: 'Dans quelles situations intervenez-vous ?',
    answer: 'Succession, déménagement, vente immobilière, syndrome de Diogène, logement insalubre, départ en maison de retraite, locaux professionnels.'
  },
  {
    id: '3',
    question: 'Débarrassez-vous aussi des encombrants lourds ? (piano, meubles massifs…)',
    answer: 'Oui tout à fait. Nous adaptons l\'équipe et mobilisons les moyens nécessaires.'
  },
  {
    id: '4',
    question: 'Vous déplacez-vous pour un petit volume (une cave, un garage, quelques meubles) ?',
    answer: 'Oui. Nous proposons des solutions adaptées au volume, avec un devis clair et au juste prix.'
  },
  {
    id: '5',
    question: 'Comment est calculé le prix d\'un débarras ?',
    answer: 'Le tarif dépend du volume, de l\'accessibilité, du temps estimé, des frais de traitement (déchetterie/tri).'
  },
  {
    id: '6',
    question: 'Proposez-vous un devis gratuit ?',
    answer: 'Oui, un devis gratuit est effectué après une visite sur place.'
  },
  {
    id: '7',
    question: 'Facturez-vous des frais cachés ?',
    answer: 'Non. Le devis détaille l\'intervention. Si un imprévu majeur apparaît (accès bloqué, volume très supérieur à ce qui avait été convenu lors de la visite), nous vous informons avant d\'agir.'
  },
  {
    id: '8',
    question: 'Que se passe-t-il si je veux garder certains objets ?',
    answer: 'Aucun souci : vous nous indiquez ce que vous gardez. Nous pouvons aussi aider à regrouper/mettre de côté dans une pièce ce que vous souhaitez conserver. Une livraison facturée en supplément peut être effectuée.'
  },
  {
    id: '9',
    question: 'Où vont les objets après le débarras ?',
    answer: 'Selon le cas : réemploi, dons à des associations partenaires, recyclage, déchetterie professionnelle. Objectif : minimiser la part jetée.'
  },
  {
    id: '10',
    question: 'En combien de temps intervenez-vous ?',
    answer: 'Selon planning et volume : parfois en urgence (48/72h), sinon sur rendez-vous. Le plus généralement dans les 10 jours qui suivent la date de validation du devis.'
  },
  {
    id: '11',
    question: 'Dois-je être présent(e) le jour du débarras ?',
    answer: 'Non, nous pouvons intervenir avec remise de clés (notaire, agence, voisin…). Des photos du lieu débarrassé vous seront envoyées, une fois le débarras réalisé.'
  },
  {
    id: '12',
    question: 'Êtes-vous assurés ?',
    answer: 'Oui, l\'activité est couverte par une assurance professionnelle (attestation possible sur demande).'
  },
  {
    id: '13',
    question: 'Diogène ou logement très encombré : intervenez-vous ?',
    answer: 'Oui. Nous évaluons le niveau d\'hygiène et de sécurité et nous vous proposons une intervention adaptée, parfois en plusieurs étapes.'
  },
  {
    id: '14',
    question: 'Comment se déroule un débarras ?',
    answer: 'Nous organisons un rendez-vous pour évaluer le volume et l\'accessibilité. Nous établissons ensuite un devis gratuit et sans engagement. Une fois accepté, nous intervenons rapidement pour procéder au tri, au retrait du mobilier et au recyclage. Tout est géré de A à Z.'
  },
  {
    id: '15',
    question: 'Intervenez-vous rapidement ?',
    answer: 'Oui, nous intervenons en 48 à 72 heures sur l\'ensemble de nos zones d\'intervention (Annecy, Genevois, Savoie et zones de montagne). Pour les urgences, n\'hésitez pas à nous contacter directement par téléphone.'
  },
  {
    id: '16',
    question: 'Que faites-vous des objets récupérés ?',
    answer: 'Nous trions systématiquement : les objets en bon état sont donnés à des associations (Emmaüs, Croix-Rouge), les objets valorisables sont revendus, et le reste est recyclé en déchetterie agréée. Nous privilégions l\'économie circulaire.'
  },
  {
    id: '17',
    question: 'Intervenez-vous dans les appartements sans ascenseur ?',
    answer: 'Oui, nos équipes sont formées et équipées pour intervenir dans tous types de logements, même aux étages sans ascenseur. Nous utilisons du matériel adapté et protégeons les parties communes.'
  }
];
